import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { Device } from '../types/state'

const initialState: Device = {
  deviceId: '',
  deviceCapabilities: [],
}

export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDevice: (state, action: PayloadAction<Device>) => {
      const { deviceId, deviceCapabilities } = action.payload
      state.deviceId = deviceId
      state.deviceCapabilities = deviceCapabilities
    },
  },
})

export const { setDevice } = deviceSlice.actions

export default deviceSlice.reducer
